import React from 'react';
import {Link} from '@shopify/hydrogen';
// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Popover} from '@headlessui/react';
import {Portal} from '@radix-ui/react-portal';
import SanityImage from '../media/SanityImage.client';
import sanityConfig from '../../../sanity.config';
export default function MenuBar({menu}: {menu: any}) {
  return (
    <div
      style={{scrollbarWidth: 'none'}}
      className="relative top-0 z-10 flex w-full translate-y-[48px] space-x-4 overflow-x-scroll bg-hk-deep-blue px-2 py-2 text-sm font-normal text-white md:hidden"
    >
      {menu?.map((item: any) => {
        const firstColLink = item?.col_1_links?.links.find(
          (l: any) => l.is_group,
        );
        const secondColLink = item?.col_2_links?.links.find(
          (l: any) => l.is_group,
        );
        const thirdColLink = item?.col_3_links?.links.find(
          (l: any) => l.is_group,
        );
        const fourthColLink = item?.col_4_links?.links.find(
          (l: any) => l.is_group,
        );
        const fifthColLink = item?.col_5_links?.links.find(
          (l: any) => l.is_group,
        );
        return (
          <div key={`${item._key}-bar`} className="whitespace-nowrap text-xs md:text-sm">
            {item._type === 'linkInternal' && (
              <Link to={item.slug}>{item.title}</Link>
            )}
            {item._type === 'linkMegaMenu' && (
              <Popover>
                {({open}) => (
                  <>
                    <Popover.Button>
                      <div className="flex items-center space-x-1">
                        <span className="">{item.title}</span>
                        <div className="">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={`${open && 'rotate-180'}`}
                          >
                            <path
                              d="M9.75 4.5L6 8.25L2.25 4.5"
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    </Popover.Button>
                    <Portal>
                      <Popover.Panel>
                        <div
                          style={{scrollbarWidth: 'none'}}
                          className="fixed top-0 left-0 z-[1000] flex w-full translate-y-[118px] justify-between overflow-x-scroll bg-white py-3 text-black"
                        >
                          {firstColLink && (
                            <Link to={firstColLink?.slug}>
                              <div className="relative flex flex-col items-center space-y-2 text-center text-xs">
                                <div className="w-8">
                                  <SanityImage
                                    dataset={sanityConfig.dataset}
                                    layout="responsive"
                                    projectId={sanityConfig.projectId}
                                    sizes={['50vw, 100vw']}
                                    src={firstColLink?.icon?.asset._ref}
                                  />
                                </div>
                                <span className="w-[75px]">
                                  {firstColLink?.title}
                                </span>
                              </div>
                            </Link>
                          )}
                          {secondColLink && (
                            <Link to={secondColLink?.slug}>
                              <div className="relative flex flex-col items-center space-y-2 text-center text-xs">
                                <div className="w-8">
                                  <SanityImage
                                    dataset={sanityConfig.dataset}
                                    layout="responsive"
                                    projectId={sanityConfig.projectId}
                                    sizes={['50vw, 100vw']}
                                    src={secondColLink?.icon?.asset._ref}
                                  />
                                </div>
                                <span className="w-[75px]">
                                  {secondColLink?.title}
                                </span>
                              </div>
                            </Link>
                          )}
                          {thirdColLink && (
                            <Link to={thirdColLink?.slug}>
                              <div className="relative flex flex-col items-center space-y-2 text-center text-xs">
                                <div className="w-8">
                                  <SanityImage
                                    dataset={sanityConfig.dataset}
                                    layout="responsive"
                                    projectId={sanityConfig.projectId}
                                    sizes={['50vw, 100vw']}
                                    src={thirdColLink?.icon?.asset._ref}
                                  />
                                </div>
                                <span className="w-[75px]">
                                  {thirdColLink?.title}
                                </span>
                              </div>
                            </Link>
                          )}
                          {fourthColLink && (
                            <Link to={fourthColLink?.slug}>
                              <div className="relative flex flex-col items-center space-y-2 text-center text-xs">
                                <div className="w-8">
                                  <SanityImage
                                    dataset={sanityConfig.dataset}
                                    layout="responsive"
                                    projectId={sanityConfig.projectId}
                                    sizes={['50vw, 100vw']}
                                    src={fourthColLink?.icon?.asset._ref}
                                  />
                                </div>
                                <span className="w-[75px]">
                                  {fourthColLink?.title}
                                </span>
                              </div>
                            </Link>
                          )}
                          {fifthColLink && (
                            <Link to={fifthColLink?.slug}>
                              <div className="relative flex flex-col items-center space-y-2 text-center text-xs">
                                <div className="w-8">
                                  <SanityImage
                                    dataset={sanityConfig.dataset}
                                    layout="responsive"
                                    projectId={sanityConfig.projectId}
                                    sizes={['50vw, 100vw']}
                                    src={fifthColLink?.icon?.asset._ref}
                                  />
                                </div>
                                <span className="w-[75px]">
                                  {fifthColLink?.title}
                                </span>
                              </div>
                            </Link>
                          )}
                        </div>
                        <Popover.Button>
                          <div className="fixed top-0 left-0 h-screen w-full bg-black bg-opacity-20"></div>
                        </Popover.Button>
                      </Popover.Panel>
                    </Portal>
                  </>
                )}
              </Popover>
            )}
          </div>
        );
      })}
    </div>
  );
}
